import { render, staticRenderFns } from "./BrandAdd.vue?vue&type=template&id=8ef75cbc"
import script from "./BrandAdd.vue?vue&type=script&lang=js"
export * from "./BrandAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports